import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CollegeService } from '@app/_services/masters/college.service';
import { college } from '@app/_models/college';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LogService } from '../../../_shared/log.service'


@Component({
  selector: 'app-college-master-add',
  templateUrl: './college-master-add.component.html',
  styleUrls: ['./college-master-add.component.css']
})
export class CollegeMasterAddComponent implements OnInit {

  college = new college();

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private collegeService: CollegeService,
    private modalService: NgbModal, config: NgbModalConfig, private router: Router) { }

  collegeForm: FormGroup;
  submitted = false;
  strMessage:string;
  getresponse: any;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  returnUrl;

  ngOnInit(): void {
    this.collegeForm = this.formBuilder.group({
      collegeName: ['', Validators.required]
    });
  }
  get f() { return this.collegeForm.controls; }

  addCollege() {
    this.submitted = true;

    if (this.collegeForm.invalid) {
      return;
    }
    this.collegeService.addCollege(this.college)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage="College Added Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
   
        else if (this.getresponse.respMessage == "Failure") {
          this.strMessage=this.getresponse.respData;
          this.modalService.open(this.showModalBoxTemplate);
          var v = response;
        }
      }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('13');
  }

  goBack()
  {
    this.eventService.emit<string>('13');
  }





}
